module.exports = __webpack_public_path__ + "static/media/duluth-desktop.e6761475.webp";